import {
  CButton,
  CLink,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react'
import React, { useState } from 'react'
import './TermsAndConditions.scss'

const TermsAndConditions = () => {
  const [visible, setVisible] = useState(false)

  const toggleModal = (evt) => {
    evt.preventDefault()
    setVisible(!visible)
  }
  return (
    <div className="terms-and-conditions-check">
      <div className="tos-text">
        Hiermit stimme ich den <br /> <CLink
        style={ { cursor: 'pointer' } } onClick={ toggleModal }
      >Nutzungsbedingungen</CLink> zu.
      </div>
      <CModal alignment="center" visible={ visible } onClose={ () => setVisible(false) }>
        <CModalHeader>
          <CModalTitle>Nutzungsbedingungen</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div style={ { textAlign: 'justify' } }>
            <p>
              Mit der Verwendung von PPS-Wallet stimme ich den folgenden Nutzungsbedingungen zu.
            </p>

            <h6>
              Datenerfassung durch das Wallet
            </h6>
            <p>
              Die Datenverarbeitung dieser Wallet-Karte erfolgt durch PPS GmbH, Bahnhofstr. 172, 83346 Bergen, um Ihnen diese Wallet-Karte zur Verfügung zu
              stellen.
            </p>
            <p>
              Details entnehmen Sie bitte der Datenschutzerklärung
              <br/>
              <a style={ { wordBreak: 'break-all' } } href="https://pps-wallet.de/datenschutzerklaerung/">https://pps-wallet.de/datenschutzerklaerung/</a>
            </p>
            <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in den
               Kontaktfeldern eingeben.</p>
            <p>Andere Daten werden automatisch oder nach Ihrer Einwilligung bei der Nutzung der Wallet-Karte erfasst. Das sind vor allem technische Daten (z. B.
               Uhrzeit des Wallet-Aufrufs, IP-Adresse etc.). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie die Wallet- Karte nutzen.</p>

            <h6>PPS Wallet nutzt Amazon Web Services</h6>
            <p>
              Die Wallet-Karte basiert auf PPS-Wallet der PPS GmbH (Bahnhofstr. 172, 83346 Bergen, Deutschland, www.pps-wallet.de) und nutzt zur Bereitstellung
              seiner Dienste Amazon Web Services Inc. (AWS) mit Sitz in den USA (410 Terry Avenue North, Seattle WA 98109).
            </p>
            <p>
              Die über die Plattform PPS Wallet erhobenen Daten werden auf der IT-Infrastruktur von AWS in der AWS-Verfügbarkeitszone »Frankfurt/Deutschland«
              gespeichert. AWS garantiert, die Daten nicht außerhalb der Verfügbarkeitszone zu transferieren <br/>(<a
              style={ { wordBreak: 'break-all' } }
              href="https://aws.amazon.com/de/compliance/germany-data-protection/"
            >https://aws.amazon.com/de/compliance/germany-data-protection/</a>).
            </p>
            <p>AWS verfügt über international anerkannte Zertifizierungen, die von unabhängigen renommierten Beratungsgesellschaften attestiert wurden und die
               Erfüllung höchster Sicherheitsanforderungen nachweisen.</p>
            <p>Mit AWS wurden die Standardvertragsklauseln, als auch einen Auftragsverarbeitungs- Vertrag nach Art. 28 DSGVO geschlossen, mit denen AWS
               versichert, Ihre Daten entsprechend der DSGVO zu verarbeiten.</p>
            <p>
              Diese Wallet-Karte wird auf Ihrem Smartphone, je nach Typ, über Apple Wallet (Apple Inc.) oder Google Wallet (Google Inc.) bereitgestellt. Auch
              bei diesen beiden Anbietern handelt es sich um US-Unternehmen. Der Datenübermittlung in die USA stimmen Sie mit der Nutzung von Apple Wallet oder
              Google Wallet zu. Nähere Informationen entnehmen Sie bitte den Datenschutzbestimmungen von Apple und Google:
              <br />
              <a
                style={ { wordBreak: 'break-all' } } href="https://www.apple.com/de/legal/privacy/data/de/wallet/"
              >https://www.apple.com/de/legal/privacy/data/de/wallet/</a>
              <br />
              <a style={ { wordBreak: 'break-all' } } href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>
            </p>

            <h6>Datenverarbeitung in den USA</h6>
            <p>PPS Wallet verwendet Hosting-Dienste von AWS mit Sitz in den USA. Dabei könnten theoretisch ihre personenbezogenen Daten (bspw. IP-Adresse) in
               die USA übertragen und dort verarbeitet werden. Wir weisen darauf hin, dass in diesen Ländern kein mit der EU vergleichbares Datenschutzniveau
               garantiert werden kann.</p>
            <p>Beispielsweise sind US-Unternehmen dazu verpflichtet, personenbezogene Daten an Sicherheitsbehörden herauszugeben, ohne dass Sie als Betroffener
               hiergegen gerichtlich vorgehen könnten. Es kann daher nicht ausgeschlossen werden, dass US-Behörden (z. B. Geheimdienste) Ihre auf US-Servern
               befindlichen Daten zu Überwachungszwecken verarbeiten, auswerten und dauerhaft speichern. Wir haben auf diese Verarbeitungstätigkeiten keinen
               Einfluss.</p>

            <h6>
              Widerruf Ihrer Einwilligung zur Datenverarbeitung</h6>
            <p>Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit
               widerrufen, in dem Sie die Wallet- Karte von Ihrem Smartphone deinstallieren. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung
               bleibt vom Widerruf unberührt.</p>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={ () => setVisible(false) }>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default TermsAndConditions
